import React from "react";

import { Grid, H3, Icon, P } from "@nel-ui/react";

import { ICommonErrorProps } from "../../interfaces";

import "./style.css";

const mainClass = "common-error";

const CommonError: React.FC<ICommonErrorProps> = (props: ICommonErrorProps) => {
  const { heading, subHeading } = props;
  return (
    <>
      <Grid align={"center"}>
        <Icon
          data-testid={`${mainClass}-icon`}
          name={"info-error"}
          width={50}
          height={49.979}
          className={`${mainClass}__info-icon`}
        />
      </Grid>
      <Grid align={"center"}>
        <H3
          as="h2"
          className={`${mainClass}__center-content`}
          data-testid={`${mainClass}-heading`}
        >
          {heading}
        </H3>
        <P
          className={`${mainClass}__center-content`}
          data-testid={`${mainClass}-sub-heading`}
        >
          {subHeading}
        </P>
      </Grid>
    </>
  );
};

export default CommonError;
